import axios from 'axios'
// import { getLodop } from "@/plugin/LodopFuncs";

var qs = require('qs');
var root=window.API_ROOT

//顺丰下单接口
export const sfOrderService = (params) => {
  return axios.post(root + '/api/express/OrderService', qs.stringify(params))
}

//取消订单
export const sfOrderConfirm = (params) => {
  return axios.post(root + '/api/express/OrderConfirm', qs.stringify(params))
}

export const sfRouteService = (params) => {
  return axios.post(root + '/api/express/RouteService', qs.stringify(params), {noloading: true})
}

export const sfOrderPrint = (params) => {
  return axios.post(root + '/api/express/OrderPrint', qs.stringify(params), {noloading: true})
}


export const loadPrintFile = (params,cangkucode,callback,needopen) => {
  var arr = JSON.parse(params);
  axios.get(arr[0].url, {responseType: "blob", headers: {"X-Auth-token": arr[0].token}}).then(response => {
    var url = "/api/pdf/expressprint?url=" + encodeURI(arr[0].url) + "&token=" + encodeURI(arr[0].token);
    if (needopen) {
      window.open(root + url);
      return;
    }

    var now = new Date();
    axios.post(root + '/api/pdf/saveStoreprint', qs.stringify({
      opcontent: url,
      filetype: "pdf",
      express: arr[0].express ? arr[0].express : "顺丰",
      cangkucode: cangkucode,
      waybillNo: arr[0].waybillNo + (now.getMonth() + 1) + "-" + now.getDate()
    }), {noloading: true}).then(resPrint => {
      callback();
    });
  });
}





// WEBPACK FOOTER //
// ./src/api/order/express.js